import request from '@/utils/request'

export function fetchList(data) {
  return request({
    url: '/Program/List',
    method: 'post',
    data,
  })
}

export function getItem(id) {
  return request({
    url: '/Program/Get',
    method: 'post',
    data: { id },
  })
}

export function createItem(data) {
  console.log('createItem', data)

  return request({
    url: '/Program/Create',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  console.log('updateItem', data)

  return request({
    url: '/Program/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/Program/Delete',
    method: 'delete',
    data,
  })
}

export function fetchAll() {
  return request({
    url: '/Program/List',
    method: 'post',
    data: {
      page: 0,
      limit: 0,
    },
  })
}
